import { ContainsWatchlistItemRequest, ContainsWatchlistItemResponse, ReorderWatchlistRequest, ToggleWatchlistGroupViewRequest, UserWatchlists, Watchlist, Watchlist_GroupBy, Watchlist_WatchlistItem } from '../../proto/generated/watchlist'
import api from './axiosClient'
import { AppDispatch } from '../../store'
import { saveUserWatchlists, setCommunityWatchlists } from '../../reducer/watchList.reducer'
import { AddToWatchlistRequest } from '../../proto/generated/screener'

export const fetchWatchlists = async (args: { dispatch: AppDispatch }): Promise<UserWatchlists> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/list`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = UserWatchlists.decode(new Uint8Array(response.data))
            decodedData.watchlists.sort((a, b) => a.priority - b.priority);
            args.dispatch(saveUserWatchlists(decodedData))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const createWatchlist = async (args: { body: any }): Promise<Watchlist> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists`
        api.post(url, JSON.stringify(args.body), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = Watchlist.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}
export const renameWatchlist = async (args: {
    watchlistId: string,
    name: string,
    body: any
}): Promise<Watchlist> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/${args.watchlistId}/rename`
        api.post(url, JSON.stringify(args.body), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            params: {
                name: args.name
            },
            data: JSON.stringify(args.body),
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = Watchlist.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const reorderWatchlistItem = async (args: { watchlistId: string, body: any }): Promise<void> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/${args.watchlistId}/reorder`
        api.post(url, JSON.stringify(args.body), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            data: JSON.stringify(args.body),
            responseType: 'arraybuffer'
        }).then(async (response) => {
            resolve()
        }).catch((error) => {
            reject(error)
        })
    })
}

export const changeWatchlistSecurities = async (args: {
    watchlistItem: Watchlist_WatchlistItem | ReorderWatchlistRequest,
    watchlistId: string,
    method: string
}): Promise<void> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/${args.watchlistId}/item`
        api.request({
            url: url,
            headers: {
                'Accept': 'application/x-protobuf'
            },
            method: args.method,
            data: JSON.stringify(args.watchlistItem),
            responseType: 'arraybuffer'
        }).then(async (response) => {
            resolve()
        }).catch((error) => {
            reject(error)
        })
    })
}

export const renameWatchlistSection = async (args: {
    watchlistId: string;
    sectionName: string;
    name: string;
}): Promise<Watchlist> => {
    const url = `/watchlists/${args.watchlistId}/${encodeURIComponent(args.sectionName)}/rename`;

    try {
        const response = await api.post(url, null, {
            headers: {
                'Accept': 'application/x-protobuf',
            },
            params: {
                name: args.name,
            },
            responseType: 'arraybuffer',
        });
        return Watchlist.decode(new Uint8Array(response.data));
    } catch (err) {
        throw err;
    }
};


export const deleteWatchlist = async ({
    dispatch,
    watchlistId,
}: {
    dispatch: AppDispatch
    watchlistId: string
}): Promise<void> => {
    const url = `/watchlists/${watchlistId}`

    try {
        await api.delete(url)

    } catch (error) {
        console.error('Failed to delete watchlist:', error)
        throw error
    }
}

export const reorderWatchlist = async (args: { watchlistId: string, body: any }): Promise<void> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/reorder`
        api.post(url, JSON.stringify(args.body), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            data: JSON.stringify(args.body),
            responseType: 'arraybuffer'
        }).then(async (response) => {
            resolve()
        }).catch((error) => {
            reject(error)
        })
    })


}

export const fetchCommunityWatchList = async (args: { dispatch: AppDispatch }): Promise<UserWatchlists> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/community`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = UserWatchlists.decode(new Uint8Array(response.data))
            args.dispatch(setCommunityWatchlists(decodedData))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const getSharedWatchlist = async (args: { shareId: string }): Promise<Watchlist> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/community/${args.shareId}`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = Watchlist.decode(new Uint8Array(response.data))
            resolve(decodedData)
    }).catch((error) => {
        reject(error)
    })
})
}

export const addCommunityToWatchList = async (args: { shareId: string, body: any }): Promise<Watchlist> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/add/${args.shareId}`
        api.post(url, JSON.stringify(args.body), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            data: JSON.stringify(args.body),
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = Watchlist.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const setDefault = async (args: { watchListId:string }): Promise<Watchlist> => {
    return new Promise((resolve, reject) => {
        const url = `watchlists/${args.watchListId}/default`
        api.post(url, JSON.stringify(args.watchListId), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            if (response.status !== 200) reject('not updated')
            else {
                const decodedData = Watchlist.decode(new Uint8Array(response.data))
                resolve(decodedData)
            }
        }).catch((error) => {
            reject(error)
        })
    })
}

export const addScreenToMyWatchlist = async (request : AddToWatchlistRequest): Promise<Watchlist> => {
    return new Promise((resolve, reject) => {
        const url = `/user-screener-layouts/add-screener-watchlist`
        api.post(url , request , {
            headers: {
                'Accept': 'application/x-protobuf',
                'Content-Type': 'application/json'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = Watchlist.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const getWatchlist = async (args: { watchlistId: string}): Promise<Watchlist> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/${args.watchlistId}`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = Watchlist.decode(new Uint8Array(response.data))
            decodedData.watchlistItems.sort((a, b) => a.priority - b.priority);
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const toggleGroupViewInSourceWatchlist = async (watchList: string , groupView : boolean): Promise<void> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/${watchList}/group-view`
        api.post(url, { groupView }, {
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(async (response) => {
            resolve(response.data)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const isSecurityAddedToWatchlists = async (request: ContainsWatchlistItemRequest): Promise<ContainsWatchlistItemResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/watchlists/contains`
        api.post(url, request , {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async (response) => {
            resolve(response.data)
        }).catch((error) => {
            reject(error)
        })
    })
}
